import { Action, Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import moment from 'moment';
import { EdgeSignatureApi } from '@trialcard/apigateway.client';
import { Field, Recipient } from '@trialcard/apigateway.models';
import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { CommonTools } from '../components/tools/commonTools';
import PathModule from './path';
import LayoutModule from './layout';
import EnrollmentModule from './enrollment';
import { Settings } from '~/services/settings';

@InjectModule({ stateFactory: true }, module)
export default class DocusignModule extends InjectVuexModule {
    @Resolve
    settings!: Settings;
    @Resolve
    pathModule!: PathModule
    @Resolve
    layout!: LayoutModule;
    @Resolve
    enrollment!: EnrollmentModule;
    @Resolve
    edgeSignature!: EdgeSignatureApi;

    envelopeId = '';
    recipientViewURL = '';
    eventType: string | null = null;

    selectTemplate() {
        const language = this.layout.isSpanish ? 'Spanish' : 'English';
        const { path } = this.pathModule;
        const templateId = this.settings[`${path}TemplateId${language}` as keyof Settings]
        console.log(templateId)
        return templateId as string;
    }

    selectBrandId() {
        const language = this.layout.isSpanish ? 'Spanish' : 'English';
        const brandId = this.settings[`brandId${language}` as keyof Settings];
        return brandId as string;
    }

    structureCreateEnvelopeRequest(payload:{fields: Field[], recipients: Recipient[]}) {
        const {
            dateOfBirth,
            emailAddresses,
            phoneNumbers,
        } = this.enrollment.patientInformationData
        const { path } = this.pathModule;
        const firstName = CommonTools.titleCase(this.enrollment.patientInformationData.firstName || '');
        const lastName = CommonTools.titleCase(this.enrollment.patientInformationData.lastName || '');
        const patEmail = emailAddresses.length > 0 && emailAddresses[0].address || '';
        const repEmail = this.enrollment.repInformation.representativeEmail;
        const phone = phoneNumbers.length > 0 && phoneNumbers[0].phoneNumber || '';
        const patName = CommonTools.titleCase(`${firstName} ${lastName}`);
        const representative = this.enrollment.contacts.length > 0 && this.enrollment.contacts[0] || {};
        const repName = CommonTools.titleCase(`${representative.firstName} ${representative.lastName}`);
        const zipCode = this.enrollment.patientInformationData.addresses.length > 0 && this.enrollment.patientInformationData.addresses[0].zip || '';
        const request = {
            programId: +this.settings.programId,
            urlSource: "https://www.ApplyOrgovyxPAP.com",
            documentType: 'SRF', // Hard coded for now based on documentation from Team Code Brigade
            brandId: this.selectBrandId(),
            senderId: this.settings.senderId,
            templateId:  this.selectTemplate(),
            expireInDays: +this.settings.expireInDays,
            emailSubject: ' ',
            emailBody: ' ',
            send: true, // Send needs to be set to true to request a RecipientView.
            embedded: true, // Embedded needs to be set to true for envelope intended for RecipientView
            recipients: payload.recipients,
            fields: payload.fields,
        };
        return request;
    }

    structureRecipientViewUrlRequest(obj:{email:string,fullName:string}) {


        const request = {
            programId: +this.settings.programId,
            envelopeId: this.envelopeId,
            email:obj.email,
            name:obj.fullName,
            returnUrl:  this.layout.isSpanish ? `${CommonTools.getBaseUrl(window.location.href, this.settings)}success?language=spanish`: `${CommonTools.getBaseUrl(window.location.href, this.settings)}success?language=english`,
        };
        return request;
    }

    @Action({})
    async createEnvelope(payload:{fields: Field[], recipients: Recipient[]}) {
        let isSuccessful = false;
        const request = this.structureCreateEnvelopeRequest(payload);
        try {
            const axios: AxiosInstance = (this.edgeSignature as any).axios;
            const axiosRequest: AxiosRequestConfig = {
                url: 'edge/signature/v1/EmailSignatureTemplate/CreateEnvelope',
                method: 'POST',
                data: request,
                headers: {
                    'x-program-id': this.settings.programId!,
                },
            };
            console.log( (this.edgeSignature as any).authentications)
            await Promise.all([
                (this.edgeSignature as any).authentications.Token.applyToRequest(axiosRequest),
            ]);
            const { data } = await axios.request(axiosRequest);
            const envelopeId = data && data.data && data.data.envelopeId || '';
            if (!envelopeId) throw new Error('Envelope creation failed')
            this.setEnvelopeId(envelopeId);
            isSuccessful = true;
        } catch(error) {
            console.error('Error from creating Docusign envelope:',error);
        }
        return isSuccessful
    }

    @Action({})
    async requestURL(obj:{email:string,fullName:string}) {
        let isSuccessful = false;
        const request = this.structureRecipientViewUrlRequest(obj);
        try {
            const response = (await this.edgeSignature.recipientViewRequestUrl(request)).data;
            const recipientViewURL = response && response.data && response.data.url || '';
            if (!recipientViewURL) throw new Error('Getting URL failed')
            await this.setRecipientViewURL(recipientViewURL);
            isSuccessful = true;
        } catch(error) {
            console.error('Error from requesting recipient view URL:',error);
        }
        return isSuccessful;
    }

    @Mutation
    setEnvelopeId(envelopeId: string) {
        this.envelopeId = envelopeId;
    }

    @Mutation
    setRecipientViewURL(recipientViewURL: string) {
        this.recipientViewURL = recipientViewURL;
    }

    @Mutation
    setEventType(eventType: string | null) {
        this.eventType = eventType;
    }

}
